import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'
const RootPage = lazy(() => import('modules/incentives/pages/RootPage'))
const CompensationPlansList = lazy(() => import('modules/incentives/pages/CompensationPlansList'))

export const incentivesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.compensations.incentives.path,
      element: <RootPage />,
      children: [
        {
          index: true,
          element: <Navigate to={navigation.compensations.incentives.plans.path} replace />,
        },
        {
          path: navigation.compensations.incentives.plans.path,
          element: <CompensationPlansList />,
        },
      ],
    },
  ]
}
